export enum CreatePatientStates {
  Initial = 'initial',
  MailFree = 'mail-free',
  MailExists = 'mail-exists',
  Error = 'error',
}
